import React, { useState, useContext, useRef, useEffect } from "react";
import axios from "axios";
import { API } from "../../../../services/api";
import '../../../../css/posOrder.css';
import '../../../../css/BillForKitchen.css';
import logo from '../../../../img/logo/ManeeCafeLogo.jpg';
import { POSContent } from "../pos";
import { useReactToPrint } from 'react-to-print';
import { UserContext } from "../../../../App";
import SelectSugar from "./selectSugar";
import backimg from '../../../../img/backimg.jpg';



axios.defaults.baseURL = API;

function PosOrder() {

    const {userID, UserName, LocationID, LocationName, Address, Tell, Role} = useContext(UserContext);
    const {setShowPayment, showOrder, TempOrder, setTempOrder, setShowOrder, serverName, QueueID, QueueNumber, setQueueID, 
        setQueueNumber, showSelectSugar, setShowSelectSugar, LaoName, setLaoName, ProductID, setProductID, qty, setqty, 
        Retail_Price, setRetail_Price, EngName, setEngName, ProductType, setProductType,ImgUrl, setImgUrl,
        subTotal, setSubTotal, setNetTotal, NewNetTotal, setNewNetTotal, setTax, showAlert, setShowAlert, setTableList, errorMessage, setErrorMessage} = useContext(POSContent);





    const [menuList, setMenuList] = useState([]);
    const [subMenuList, setSubMenuList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [TakeAway, setTakeAway] = useState("Dine In (ກິນຢູ່ຮ້ານ)");
    const [tw, setTw] = useState(false);
    const [PrintCount, setPrintCount] = useState(1);
    const [Barcode, setBarcode] = useState([]);
    const [Quantity, setQuantity] = useState(1);

    const scrollRef = useRef(null);
    const handleWheel = (e) => {
    // If the user scrolls vertically, redirect it horizontally
        if (e.deltaY !== 0) {
        e.preventDefault(); // Stop the main page from scrolling vertically
            scrollRef.current.scrollLeft += e.deltaY;
        }
    };


    function currencyFormat(num) {
        if (num !== "" && num > 0) {
            return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    }

    const handleInputPrintCount = event => { 
        const { name, value } = event.target;
        setPrintCount(value)
    };

    async function handleClickMenuToGetSubmenu(MenuID) {
        let token = localStorage.getItem("token");
        await axios.get(`/getSubMenuByMenuID/${MenuID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
          let temOrder = response?.data;
          if(temOrder.length > 0){
            setSubMenuList(temOrder);
            setProductList([]);
          } else {
            setSubMenuList([]);
            setProductList([]);
          }
        }).catch((err) => {
            setSubMenuList([]);
            setProductList([]);
            console.log(err);
        });
    };

    const handleInputChange = event => {
        setQuantity(event.target.value);
    };

    async function handleClickSubMenuToGetProductList (CategoryID) {
        if(CategoryID){
          let token = localStorage.getItem("token");
          await axios.put(`/getProductBySubmenu/${CategoryID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
                console.log(temOrder);
                setProductList(temOrder);
            } else {
                setProductList([]);
            }
          }).catch((err) => {
            setProductList([]);
            console.log(err);
          });
        } else {
            setProductList([]);
        }
      }

    async function addOrder(ProductID, ProductType, Retail_Price, LaoName, EngName, gqty, y, ImgUrl) {
        if(gqty > 0){
            if(ProductType == "Drink" || ProductType == "DRINK" || ProductType == "Coffee" || ProductType == "COFFEE" || ProductType == "SMOOTHIE" || ProductType == "Smoothie"){
                setLaoName(LaoName);
                setProductID(ProductID);
                setqty(gqty);  
                setRetail_Price(Retail_Price);
                setEngName(EngName);
                setProductType(ProductType);
                setShowSelectSugar(true);
                setImgUrl(ImgUrl);
            } else {
                var c =0;
                for (var i=0; i < TempOrder.length; i++) {
                    if (TempOrder[i].ProductID == ProductID) {
                        if(Number(TempOrder[i].Quantity) + Number(gqty) > 0)
                        {
                            TempOrder[i].Quantity = Number(TempOrder[i].Quantity) + Number(gqty);
                            TempOrder[i].SubTotal = Number(TempOrder[i].Quantity) * Number(TempOrder[i].Retail_Price);
                            if(TempOrder[i].PrintStatus === "Y"){
                                if(TempOrder[i].QuantityPrint > 0){
                                    TempOrder[i].QuantityPrint = Number(TempOrder[i].QuantityPrint) + Number(gqty);
                                } else {
                                    TempOrder[i].QuantityPrint = gqty;
                                }
                            } 
                        } else {
                            TempOrder.splice(i, 1);
                        }
                        c = 1;
                        break;
                    }
                }  
                if(c == 0){
                    var datalist = {
                        SubTotal: Retail_Price,
                        ProductID: ProductID,
                        LaoName: LaoName,
                        EngName: EngName,
                        Retail_Price: Retail_Price,
                        Quantity: Number(gqty),
                        StatusID : 1,
                        QuantityPrint : 0,
                        PrintStatus: "N",
                        ProductType: ProductType,
                    }
                    TempOrder.push(datalist);
                }
                localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));
                getSubtotal();
            }
        } else {
            for (var i=0; i < TempOrder.length; i++) {
                if (TempOrder[i].ProductID == ProductID && i == y) {
                    if(Number(TempOrder[i].Quantity) + Number(gqty) > 0)
                    {
                        TempOrder[i].Quantity = Number(TempOrder[i].Quantity) + Number(gqty);
                        TempOrder[i].SubTotal = Number(TempOrder[i].Quantity) * Number(TempOrder[i].Retail_Price);
                        if(TempOrder[i].PrintStatus === "Y"){
                            if(TempOrder[i].QuantityPrint > 0){
                                TempOrder[i].QuantityPrint = Number(TempOrder[i].QuantityPrint) + Number(gqty);
                            } else {
                                TempOrder[i].QuantityPrint = gqty;
                            }
                        } 
                    } else {
                        TempOrder.splice(i, 1);
                    }
                    break;
                }
            }  
                localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));
                getSubtotal();
        }
        
    }

    async function handleSearchProduct (e) {
        let token = localStorage.getItem("token");
        setBarcode(e.target.value);
        if(e.target.value){
            var data = {
                Barcode: e.target.value
            }
            await axios.post("/getProductByBarcode", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                let productData = response?.data;
                if(productData.length > 0){
                    addOrder(productData[0].ProductID, productData[0].Retail_Price, productData[0].LaoName, productData[0].EngName, Quantity);
                    setBarcode("");
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }

    const getSubtotal = () => {
        if (TempOrder) {
          if(TempOrder.length > 0){
                var gSubTotal = 0;
                for (var i=0; i < TempOrder.length; i++) {
                    gSubTotal = Number(gSubTotal) + Number(TempOrder[i].SubTotal);
                }  
                var gNewTax = 0;
                var gtax =  gSubTotal * (10 / 100);
                var roundUp = gtax.toString().substr(-3, 3);
                if(roundUp > 500){
                    gNewTax = (Number(gtax) - Number(roundUp)) + 1000;
                } else if(roundUp < 500) {
                    gNewTax = (Number(gtax) - Number(roundUp));
                } else {
                    gNewTax = gtax;
                }
                setTax(gNewTax);
                setSubTotal(gSubTotal);
                setNewNetTotal(gSubTotal + gNewTax);
                setNetTotal(gSubTotal + gNewTax);
            } else{
                setSubTotal(0);
                setNetTotal(0);
                setNewNetTotal(0);
                setTax(0);
            }
        } else{
            setSubTotal(0);
            setNewNetTotal(0);
            setNetTotal(0);
            setTax(0);
        }
    }

    const handleClickTakeAway = event => {
        if(tw){
            setTakeAway("Dine In (ກິນຢູ່ຮ້ານ)");
            setTw(false);
        }else {
            setTakeAway("TakeAway (ກັບບ້ານ)");
            setTw(true);
        }  
    };

    const handleShowPayment = () => {
       if(TempOrder.length > 0){
        setShowPayment(true);
       } else{
            setErrorMessage("ກະລຸນາເລືອກສິນຄ້າກ່ອນ");
            setShowAlert(true);
       }
    }

    async function getMenu() {
        axios
        .get("/getmenu")
        .then((response) => {
            let Data = response?.data;
            setMenuList(Data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    async function PrintFoodBill () {
        console.log(subTotal)
        let token = localStorage.getItem("token");
        var data = {
            Queue: QueueNumber, 
            userName: UserName, 
            SubTotal: subTotal, 
            itemData: TempOrder,
            Address: Address,
            Tell: Tell,
            PrintCount: PrintCount,
        }
        await axios.post("/printFoodBill", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    }

    async function PrintDrinkBill () {
        let token = localStorage.getItem("token");
        var data = {
            Queue: QueueNumber, 
            userName: UserName, 
            SubTotal: subTotal, 
            itemData: TempOrder,
            Address: Address,
            Tell: Tell,
        }
        await axios.post("/printDrinkBill", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        getMenu();
        getSubtotal();
      }, []);

    return (
        <div style={{ display: showOrder ? 'flex' : 'none' }} className="formPos">
            <img className="logo" src={backimg} />
            <div className="OrderContent">
                
                <div className="LeftContent">
                    <div className="title">
                        <p>Manee Arabica</p>
                    </div>
                    <div className="SubMenu">
                        {
                            subMenuList && subMenuList.map((x, y) => {
                                return (
                                    <div key={y} className="SubMenuContent" onClick={() => handleClickSubMenuToGetProductList(x.CategoryID)}>
                                        <img src={x.ImgUrl} />
                                        <p className="name">{x.Category}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="CenterContent">
                    <div className="CenterHeader">
                        <div className="user-name">{serverName}</div>
                        <div className="Search">
                            <div className="Barcode">
                                <span>Barcode</span>
                                <input type="text" className="form-control" placeholder="Search" onChange={(e) => handleSearchProduct(e)} value={Barcode} />
                            </div>
                            <div className="Qty">
                                <span>Quantity</span>
                                <input type="text" className="form-control" placeholder="1" onChange={(e) => handleInputChange(e)} value={Quantity}/>
                            </div>
                        </div>
                    </div>
                    <div className="menuContent" ref={scrollRef} onWheel={handleWheel}>
                        {
                            menuList && menuList.map((x, y) => {
                                return (
                                    <div key={y} className="FoodMenu" onClick={() => handleClickMenuToGetSubmenu(x.MenuID, x.ProductType)}>
                                        <div className="FoodMenuContent" tabIndex={y}  >
                                            <div className="item-header">
                                                <img src={x.ImgUrl} className="icon-menu"/>
                                            </div>
                                            <div className="item-body">
                                                <p className="name">{x.ProductType}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="underLine">
                        <hr />
                    </div>
                    <div className="MenuList">
                    {
                            productList && productList.map((x, y) => {
                                return (
                                    <div key={y} className="item" onClick={() => addOrder(x.ProductID, x.ProductType, x.Retail_Price, x.LaoName, x.EngName, 1, x.ImgUrl)}>
                                        <div className="item-header">
                                            <img src={x.ImgUrl} className="img-product" />
                                        </div>
                                        <div className="item-body">
                                            <div className="name">
                                                <p>{x.LaoName}</p>
                                            </div>
                                            <p className="price">{currencyFormat(x.Retail_Price)}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="RightContent">
                    <div className="billNo">
                        <div className="ordertext"><p>Order List</p></div>
                        <div className="tableNo"><p>Queue # {QueueNumber} </p></div>
                        <div className="btnclose" onClick={e => setShowOrder(false)} >X</div>
                    </div>
                    <div className="OrderHead">
                        <div className="ProductName"><p>Price</p></div>
                        <div className="Quantity">Quantity</div>
                        <div className="Price">Total</div>
                    </div>
                    <div className="posRightSidenavContent">
                        {
                            TempOrder && TempOrder.map((x, y) => {
                                return (
                                    <div key={y} className="orderContent">
                                        <div className="orderFooter">
                                            <div className="price">
                                                <p>{currencyFormat(x.Retail_Price)}</p>
                                            </div>
                                            <div className="plus" onClick={() => addOrder(x.ProductID, x.ProductType, x.Retail_Price, x.LaoName, x.EngName, 1)}>
                                                +
                                            </div>
                                            <div className="quantity">
                                                <p>{currencyFormat(x.Quantity)}</p>
                                            </div>
                                            <div className="minus" onClick={() => addOrder(x.ProductID, x.ProductType, x.Retail_Price, x.LaoName, x.EngName, -1, y)}>
                                                -
                                            </div>
                                            <div className="Subtotal">
                                                <p>{currencyFormat(x.Quantity * x.Retail_Price)}</p>
                                            </div>
                                        </div>
                                        <div className="orderBody">
                                            <div className="detail">
                                                <div className="productName">
                                                    <span>{y+1}. {x.LaoName} {x.Sugar} %</span>         
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="posRightSidenavBottom">
                        <div className="footer-subtotal">
                            <div className="footer-line"></div>
                            <div className="nettotal">
                                <span>Sutotal:</span>
                                <strong>{currencyFormat(subTotal)}</strong>
                            </div>
                        </div>
                        <div className="paymentMethod">
                            <div className="btnpayment" onClick={(e) => handleShowPayment()}>
                                <span>Payment</span>
                            </div>
                            <div className="btnPrintFood" onClick={(e) =>PrintFoodBill()} >
                                <span>Print Food</span>
                            </div>
                            <div className="btnPrintDrink" onClick={(e) =>PrintDrinkBill()}>
                                <span>Print Drink</span>
                            </div>
                        </div>
                        <div className="form-group">
                            {/* <label className="form-check form-check-inline takeAway">
                                <input className="form-check-input" type="radio" name="takeAway" value="TakeAway" onClick={(e) => handleClickTakeAway(e)} checked={tw} />
                                <span className="form-check-label"> TakeAway </span>
                            </label> */}
                            <div className="headerPrintcount">
                                <span>ຈຳນວນບິນ:</span>
                                <input className="PrintCount" type="text" name="PrintCount" placeholder="1" onChange={(e) => handleInputPrintCount(e)} value={PrintCount} required />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PosOrder;
